import moment from 'moment';
import { inRange, monthRefToRange, parseDate, startOfToday } from '../../../utils/monthRef';
import { PROD_COORDENADOR_PF_FIELDS } from '../../../utils/fc';

export const PROD_STATUS_TP_ENTREGA = 6;
export const PROD_STATUS_TP_APROVACAO = 7;
export const PROD_STATUS_TP_FATURAMENTO = 8;

export const MARCO_DISPLAY_ORDER = ['aprovacao', 'entrega', 'faturamento'];

export const PROD_DASHBOARD_FIELDS = {
  prod_dtEntrega: 'prod_dtEntrega',
  prod_dtAprov: 'prod_dtAprov',
  prod_dtLimAprov: 'prod_dtLimAprov',
  "(SELECT COUNT(*) FROM prod p WHERE p.prod_ativo = 1 AND p.prod_dtLimAprov >= DATE_FORMAT(CURDATE() - INTERVAL 1 MONTH, '%Y-%m-01') AND p.prod_dtLimAprov <  DATE_FORMAT(CURDATE(), '%Y-%m-01') AND NOT EXISTS (SELECT 1 FROM prodStatusAlt psa WHERE psa.prod_id = p.prod_id AND psa.prodStatusTp_id = 7 AND COALESCE(psa.prodStatusAlt_ativo, 1) = 1))": "prodNaoAprovadosMesAnterior",
  "(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria ASC LIMIT 1)": "prodEntregueAoClienteData",
  "(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusTp_id = 7 AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria ASC LIMIT 1)": "prodAprovacaoData",
  "(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusTp_id = 8 AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria ASC LIMIT 1)": "prodAutFatData",
  "(SELECT pfCoord.pf_emailProf FROM prodStatusAlt psa, projEquipe pe, pf pfCoord WHERE psa.prod_id = prod.prod_id AND pe.proj_id = prod.proj_id AND pfCoord.pf_id = pe.pf_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_id = (SELECT psa2.prodStatusAlt_id FROM prodStatusAlt psa2 WHERE psa2.prod_id = prod.prod_id AND psa2.prodStatusTp_id = 6 ORDER BY psa2.prodStatusAlt_data DESC, psa2.prodStatusAlt_id DESC LIMIT 1) AND pe.projAtuacao_id = 8 AND psa.prodStatusAlt_data >= pe.projEquipe_ini AND (pe.projEquipe_fim IS NULL OR psa.prodStatusAlt_data <= pe.projEquipe_fim) LIMIT 1)": "prod_responsavel_email",
  "(SELECT pfCoord.pf_nomeExibicao FROM prodStatusAlt psa, projEquipe pe, pf pfCoord WHERE psa.prod_id = prod.prod_id AND pe.proj_id = prod.proj_id AND pfCoord.pf_id = pe.pf_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_id = (SELECT psa2.prodStatusAlt_id FROM prodStatusAlt psa2 WHERE psa2.prod_id = prod.prod_id AND psa2.prodStatusTp_id = 6 ORDER BY psa2.prodStatusAlt_data DESC, psa2.prodStatusAlt_id DESC LIMIT 1) AND pe.projAtuacao_id = 8 AND psa.prodStatusAlt_data >= pe.projEquipe_ini AND (pe.projEquipe_fim IS NULL OR psa.prodStatusAlt_data <= pe.projEquipe_fim) LIMIT 1)": "prod_responsavelNome",
  '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 ORDER BY projEquipe_dtCria DESC LIMIT 1))': 'prod_responsavelNomeAtual',
  '(SELECT pf_emailProf FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 ORDER BY projEquipe_dtCria DESC LIMIT 1))': 'prod_responsavel_email_atual',
  ...PROD_COORDENADOR_PF_FIELDS,
  "(SELECT pst.prodStatusTp_nome FROM prodStatusTp pst WHERE pst.prodStatusTp_id = (SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY psa.prodStatusAlt_dtCria DESC LIMIT 1) AND pst.prodStatusTp_ativo = 1 LIMIT 1)": "prodStatusActual_nome",
  "(SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)": "prodStatusActual_id",
  "(SELECT psa.prodStatusAlt_obs FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)": "prodStatusAlt_obs",
  "(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)": "prodStatusAlt_data",
  "(SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1 OFFSET 1)": "prodStatusPenultimo_id",
  "(SELECT proj_nome FROM proj WHERE proj.proj_id = prod.proj_id)": "proj_nome",
};

export const MARCOS = {
  faturamento: {
    id: 'faturamento',
    title: 'Autorização de faturamento',
    limiteField: 'prod_dtLimAprov',
    realizadoAltField: 'prodAutFatData',
    labels: {
      pendente_em_dia: 'Pendentes em dia',
      pendente_atraso: 'Pendentes em atraso',
      concluido_prazo: 'Autorizados no prazo',
      concluido_atraso: 'Autorizados com atraso',
    },
  },
  entrega: {
    id: 'entrega',
    title: 'Entrega',
    limiteField: 'prod_dtEntrega',
    realizadoAltField: 'prodEntregueAoClienteData',
    labels: {
      pendente_em_dia: 'Pendentes em dia',
      pendente_atraso: 'Pendentes em atraso',
      concluido_prazo: 'Entregues no prazo',
      concluido_atraso: 'Entregues com atraso',
    },
  },
  aprovacao: {
    id: 'aprovacao',
    title: 'Aprovação do produto',
    limiteField: 'prod_dtAprov',
    realizadoAltField: 'prodAprovacaoData',
    labels: {
      pendente_em_dia: 'Pendentes em dia',
      pendente_atraso: 'Pendentes em atraso',
      concluido_prazo: 'Aprovados no prazo',
      concluido_atraso: 'Aprovados com atraso',
    },
  },
};

export const BUCKET_ORDER = ['pendente_em_dia', 'pendente_atraso', 'concluido_prazo', 'concluido_atraso'];

export const BUCKET_COLORS = {
  pendente_em_dia: '#5664d2',
  pendente_atraso: '#ff5757',
  concluido_prazo: '#1cbb8c',
  concluido_atraso: '#f1b44c',
};

const MONTH_NAMES = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
];

export const monthToTextFromRef = (mesRef) => {
  const m = moment(mesRef, 'YYYY-MM', true);
  if (!m.isValid()) return MONTH_NAMES[new Date().getMonth()];
  return MONTH_NAMES[m.month()];
};

export const hasResponsavel = (p) => Boolean(p.prod_responsavelNome || p.prod_responsavelNomeAtual);

export const statusId = (p) => Number(p.prodStatusActual_id) || 0;

export const PROD_STATUS_LABELS = {
  1: 'Não iniciado',
  2: 'Em Elaboração',
  3: 'Entregue ao EP',
  4: 'Entregue à Gestão',
  5: 'A entregar p/ Cliente',
  6: 'Entregue ao Cliente',
  7: 'Aprovado pelo Cliente',
  8: 'Faturamento Autorizado',
  9: 'Em correção',
};

export const prodStatusLabel = (id) => PROD_STATUS_LABELS[Number(id)] || '';

export const isNaoEntregue = (id) => id >= 1 && id <= 5;
export const isAguardandoAprovacao = (id) => id === 6;
export const isReprovado = (id) => id === 9;
export const isAprovado = (id) => {
  const n = Number(id);
  return n === 7 || n === 8;
};

export const prodRefDate = (produto) => parseDate(produto?.prod_dtLimAprov);

export const inMonthRefForField = (produto, mesRef, field) => {
  const d = parseDate(produto?.[field]);
  if (!d) return false;
  const { start, endExclusive } = monthRefToRange(mesRef);
  return inRange(d, start, endExclusive);
};

export const inMonthRef = (produto, mesRef) => inMonthRefForField(produto, mesRef, 'prod_dtLimAprov');

export const whichTriFromRef = (mesRef) => {
  const m = moment(mesRef, 'YYYY-MM', true);
  const month = m.isValid() ? m.month() : new Date().getMonth();
  if (month < 3) return 1;
  if (month < 6) return 2;
  if (month < 9) return 3;
  return 4;
};

export const inTriOfRef = (produto, mesRef) => {
  const d = prodRefDate(produto);
  if (!d) return false;
  const m = moment(mesRef, 'YYYY-MM', true);
  const year = m.isValid() ? m.year() : new Date().getFullYear();
  if (d.getFullYear() !== year) return false;
  const month = d.getMonth();
  const tri = whichTriFromRef(mesRef);
  switch (tri) {
    case 1: return month >= 0 && month < 3;
    case 2: return month >= 3 && month < 6;
    case 3: return month >= 6 && month < 9;
    case 4: return month >= 9 && month < 12;
    default: return false;
  }
};

export const inNextNDaysFromToday = (produto, n) => {
  const d = prodRefDate(produto);
  if (!d) return false;
  const today = startOfToday();
  const limit = new Date(today);
  limit.setDate(today.getDate() + n);
  return d >= today && d < limit;
};

/** Prazo do marco: somente colunas de limite em `prod`. */
export const getMarcoLimiteDate = (produto, marco) =>
  parseDate(produto?.[marco.limiteField]);

/** Realização do marco: somente `prodStatusAlt_data` do tipo correspondente. */
const getRealizadoDate = (produto, marco) =>
  parseDate(produto?.[marco.realizadoAltField]);

const isMarcoConcluido = (produto, marco) => Boolean(getRealizadoDate(produto, marco));

/** Classifica produto em um dos 4 buckets; null se sem data limite do marco. */
export const classifyMarcoBucket = (produto, marco) => {
  const limite = getMarcoLimiteDate(produto, marco);
  if (!limite) return null;

  const today = startOfToday();
  const realizado = getRealizadoDate(produto, marco);
  const concluido = isMarcoConcluido(produto, marco);

  if (!concluido) {
    return limite >= today ? 'pendente_em_dia' : 'pendente_atraso';
  }
  if (!realizado) return 'concluido_prazo';
  return realizado <= limite ? 'concluido_prazo' : 'concluido_atraso';
};

export function buildMarcoOverview(products, mesRef, marcoId) {
  const marco = MARCOS[marcoId];
  const eligible = products.filter((p) => {
    if (!hasResponsavel(p)) return false;
    const limite = getMarcoLimiteDate(p, marco);
    if (!limite) return false;
    const { start, endExclusive } = monthRefToRange(mesRef);
    return inRange(limite, start, endExclusive);
  });

  const counts = {
    pendente_em_dia: 0,
    pendente_atraso: 0,
    concluido_prazo: 0,
    concluido_atraso: 0,
  };
  const productsByBucket = {
    pendente_em_dia: [],
    pendente_atraso: [],
    concluido_prazo: [],
    concluido_atraso: [],
  };

  eligible.forEach((p) => {
    const bucket = classifyMarcoBucket(p, marco);
    if (!bucket) return;
    counts[bucket] += 1;
    productsByBucket[bucket].push(p);
  });

  return { marco, counts, productsByBucket, total: eligible.length };
}

export function buildAllMarcosOverview(products, mesRef) {
  return MARCO_DISPLAY_ORDER.reduce((acc, marcoId) => {
    acc[marcoId] = buildMarcoOverview(products, mesRef, marcoId);
    return acc;
  }, {});
}

export function countWithPacotes(list, pacotes, matchFn) {
  const fromList = list.filter((p) => !p.pacote && matchFn(p)).length;
  const fromPacotes = Object.values(pacotes || {}).flat().filter(matchFn).length;
  return fromList + fromPacotes;
}

export function buildDashboardSlices(processedList, mesRef) {
  const eligible = processedList.filter(hasResponsavel);
  const produtosMes = eligible.filter((p) => inMonthRef(p, mesRef));
  const produtosTri = eligible.filter((p) => inTriOfRef(p, mesRef));
  const produtos60Dias = eligible.filter((p) => inNextNDaysFromToday(p, 60));
  const produtos30Dias = eligible.filter((p) => inNextNDaysFromToday(p, 30));
  const produtosMesLista = [...produtosMes].sort((a, b) => {
    const da = prodRefDate(a)?.getTime() ?? 0;
    const db = prodRefDate(b)?.getTime() ?? 0;
    return da - db;
  });
  return {
    produtosMes,
    produtosTri,
    produtos60Dias,
    produtos30Dias,
    produtosMesLista,
  };
}

export const statusCounts = (list, pacotes) => ({
  naoEntregues: countWithPacotes(list, pacotes, (p) => isNaoEntregue(statusId(p))),
  aguardando: countWithPacotes(list, pacotes, (p) => isAguardandoAprovacao(statusId(p))),
  reprovados: countWithPacotes(list, pacotes, (p) => isReprovado(statusId(p))),
  aprovados: countWithPacotes(list, pacotes, (p) => isAprovado(statusId(p))),
  total: countWithPacotes(list, pacotes, () => true),
});
